import React, { useState, useEffect } from 'react';
import Header from '../components/common/Header';
import LeftColumn from '../components/parent/LeftColumn';
import RightContent from '../components/parent/RightContent';
import '../styles/parent/RightContent.css';

const ParentInterface = () => {
  const [studentName, setStudentName] = useState(null);
  
  // Debug logging
  useEffect(() => {
    console.log('🎯 ParentInterface studentName state changed:', studentName);
  }, [studentName]);

  const parentButtons = [
    { id: 1, label: 'Dashboard', icon: '📊', path: '/parent' },
    { id: 3, label: 'Settings', icon: '⚙️', path: '/parent' },
    { id: 4, label: 'Logout', icon: '🚪', path: '/' }
  ];

  return (
    <div>
      <Header buttons={parentButtons} />
      <div className="parent-main-layout">
        <LeftColumn onStudentNameLoad={setStudentName} />
        <RightContent studentName={studentName} />
      </div>
    </div>
  );
};

export default ParentInterface;